import script from "./EvalRunList.vue?vue&type=script&setup=true&lang=js"
export * from "./EvalRunList.vue?vue&type=script&setup=true&lang=js"

import "./EvalRunList.vue?vue&type=style&index=0&id=e388b0d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e388b0d2"]])

export default __exports__